<template>
    <div class="payment-fields" :class="!hideFields && 'check-form'">
        <v-text-field
            v-model="localData.amount"
            :rules="[valid.amount]"
            light
            outlined
            dense
            type="number"
            name="amount"
            :label="$t('pages.payments.enterCheckAmount')"
            class="payment-field"
            @input="emitUpdate"
        ></v-text-field>

        <v-text-field
            v-model="localData.due_date"
            :rules="[valid.due_date]"
            light
            outlined
            dense
            type="date"
            name="due_date"
            :label="$t('pages.payments.dueDate')"
            class="payment-field"
            @input="emitUpdate"
        ></v-text-field>

        <v-text-field
            v-model="localData.check_number"
            :rules="[valid.check_number]"
            light
            outlined
            dense
            type="number"
            name="check_number"
            :label="$t('pages.payments.enterCheckNumber')"
            class="payment-field"
            @input="emitUpdate"
        ></v-text-field>

        <v-autocomplete
            v-model="localData.bank_code"
            :rules="[valid.bank_code]"
            :items="bankCodes"
            :item-text="getTranslationForBankCodes"
            item-value="bank_code"
            :label="$t('pages.payments.selectBankCode')"
            outlined
            dense
            class="payment-field"
        ></v-autocomplete>

        <v-text-field
            v-model="localData.branch_number"
            :rules="[valid.branch_number]"
            light
            outlined
            dense
            type="number"
            name="branch_number"
            :label="$t('pages.payments.enterBranchNumber')"
            class="payment-field"
            @input="emitUpdate"
        ></v-text-field>

        <v-text-field
            v-model="localData.bank_account_number"
            :rules="[valid.bank_account_number]"
            light
            outlined
            dense
            type="number"
            name="bank_account_number"
            :label="$t('pages.payments.enterFullBankAccountNumber')"
            class="payment-field"
            @input="emitUpdate"
        ></v-text-field>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { paymentsV2GetterTypes } from '@/store/modules/payments_v2/types'

export default {
    props: {
        amount: {
            type: String,
            default: null,
        },
        due_date: {
            type: String,
            default: '',
        },
        check_number: {
            type: [String, Number],
            default: null,
        },
        bank_code: {
            type: [String, Number],
            default: null,
        },
        branch_number: {
            type: [String, Number],
            default: null,
        },
        bank_account_number: {
            type: [String, Number],
            default: null,
        },
        local_id: {
            type: [String, Number],
            default: null,
        },
        hideFields: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update-payment'],
    data() {
        const requiredField = (v) =>
            !!v || this.$t('pages.payments.fieldIsRequired')

        const fieldsToValidate = [
            'amount',
            'due_date',
            'check_number',
            'bank_code',
            'branch_number',
            'bank_account_number',
        ]

        return {
            localData: {
                amount: this.amount,
                due_date:
                    this.due_date || new Date().toISOString().slice(0, 10),
                check_number: this.check_number,
                bank_code: this.bank_code,
                branch_number: this.branch_number,
                bank_account_number: this.bank_account_number,
                local_id: this.local_id || null,
            },
            valid: fieldsToValidate.reduce((acc, field) => {
                acc[field] = requiredField
                return acc
            }, {}),
        }
    },
    computed: {
        ...mapGetters('paymentsV2', {
            bankCodes: paymentsV2GetterTypes.GET_BANK_CODES,
        }),
    },
    watch: {
        due_date(newValue) {
            this.localData.due_date = newValue
        },
        check_number(newValue) {
            this.localData.check_number = newValue
        },
    },
    methods: {
        emitUpdate() {
            this.$emit('update-payment', this.localData)
        },
        getTranslationForBankCodes: function (item) {
            const translatedKey = `pages.payments.${item.bank_name}`
            const translatedText = this.$t(translatedKey)

            if (translatedText.includes('Translation not found for key')) {
                return item.bank_name
            }

            return `${translatedText} ${item.bank_code}`
        },
    },
}
</script>

<style lang="scss">
.check-form {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    column-gap: 20px !important;
}
</style>
